import { render, staticRenderFns } from "./RateCards.vue?vue&type=template&id=370d819e&scoped=true&"
import script from "./RateCards.vue?vue&type=script&lang=js&"
export * from "./RateCards.vue?vue&type=script&lang=js&"
import style0 from "./RateCards.vue?vue&type=style&index=0&id=370d819e&lang=less&scoped=true&"
import style1 from "./RateCards.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370d819e",
  null
  
)

export default component.exports